import { render, staticRenderFns } from "./BaseRow.vue?vue&type=template&id=5cbf3854&scoped=true&"
import script from "./BaseRow.vue?vue&type=script&lang=js&"
export * from "./BaseRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseRow.vue?vue&type=style&index=0&id=5cbf3854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbf3854",
  null
  
)

export default component.exports